import React, { Component } from 'react';

import GlobalLayout from 'Layouts/Global.layout';

import {
  handleOTPTimerOutput,
  genericComponentTimer
} from 'Utils/Helpers/component.helpers';
import { Container, Card, Text, FormElements, Button } from 'UILib';

import 'Components/Withdraw/withdraw.style.scss';

const ENTER_KEY = 13;

class Confirm extends Component {
  constructor(props) {
    super(props);

    this.state = { otp_code: '', remaining: 60, hasDigitError: false };
  }

  componentDidMount() {
    this.timer = genericComponentTimer(() => {
      this.setState({ remaining: this.state.remaining - 1 });
    });
    document.addEventListener('keydown', (e) => {
      this.handleKeyDown(e);
    });
  }

  componentWillUnmount() {
    clearInterval(this.timer);
    document.removeEventListener('keydown', (e) => {
      this.handleKeyDown(e);
    });
  }

  componentDidUpdate(prevProps, prevState) {
    /**
     * Resets otp_code value when a wrong otp code is entered
     */
    if (
      this.props.withdraw.otp_code_tries !== prevProps.withdraw.otp_code_tries
    ) {
      this.setState({ otp_code: '' });
    }
    /**
     * Concludes phone activation flow with a failure screen when timer reaches 00:00
     */
    if (this.state.remaining === 0) {
      this.props.withdrawConfirmNoTime();
    }
  }

  handleKeyDown = (e) => {
    e.keyCode === ENTER_KEY && this.handleSubmit();
  };

  handleChange = (otp_code) => {
    this.setState({ otp_code });
  };

  handleSubmit = () => {
    const { access_token, transaction_id } = this.props.withdraw;
    const { otp_code } = this.state;
    if (otp_code.length === 6) {
      this.setState({ hasDigitError: false });
      this.props.confirmWithdraw(access_token, transaction_id, otp_code);
    } else {
      this.setState({ hasDigitError: true });
    }
  };

  render() {
    const { minutes, seconds } = handleOTPTimerOutput(this.state.remaining);
    const { otp_code } = this.state;
    const { otp_code_tries } = this.props.withdraw;
    return (
      <Container type="page" bgColor="grey-0">
        <GlobalLayout>
          <div className="withdraw-confirm-wrapper">
            <Text
              type="h1"
              textAlign="left"
              content="withdraw.confirm.header"
              translation
              className="withdraw-header"
            />
            <Text
              type="intro"
              textAlign="left"
              content="withdraw.confirm.subheader"
              translation
              className="withdraw-text"
            />
            <Card type="auth" centered className="confirm-card">
              <Text
                type="h1"
                content="withdraw.confirm.card.header"
                translation
                className="header"
              />
              <Text
                type="intro"
                content="withdraw.confirm.card.subheader"
                translation
                className="subheader"
              />
              <Text
                type="h1"
                content={`${minutes}:${seconds}`}
                className="time"
              />
              <div className="digits-container">
                <FormElements.Digit
                  type="number"
                  digits={6}
                  error={this.state.hasDigitError}
                  value={otp_code}
                  onChange={this.handleChange}
                />
                <Text
                  type="intro"
                  content={`${otp_code_tries} / 3`}
                  color="grey-2"
                  className="tries-text"
                />
              </div>
              <div className="error">
                {this.props.withdraw.error && (
                  <FormElements.ValidationErrors
                    content={`status_codes.client_codes.${
                      this.props.withdraw.error.client_code
                    }`}
                    translation
                  />
                )}
              </div>
              <div className="action-zone">
                <Button
                  content="withdraw.confirm.card.action"
                  translation
                  color="white"
                  bgColor="orange-3"
                  borderColor="orange-3"
                  className="action-button"
                  onClick={() => {
                    this.handleSubmit();
                  }}
                />
              </div>
            </Card>
          </div>
        </GlobalLayout>
      </Container>
    );
  }
}

export default Confirm;
